define('MaxMage_InternationalTelephoneInput/js/internationalTelephoneInput',[
    'jquery',
    'intlTelInput'
], function ($) {
    var initIntl = function (config, node) {
        $(node).intlTelInput(config);
    };
    return initIntl;
});
